<style scoped>
.this_promoError {
  position: absolute;
  bottom: -20px;
}
</style>
<template>
  <div class="demo__padding-top--10 demo__padding-bottom--10 animated fadeIn">
    <div
      class="demo__text-center demo__font--24 demo__weight--600 demo__text-left-mobile demo__font-mobile--18 demo__width-mobile-230"
    >
      <span class="demo__inline demo__color--black">
        {{ $t("Subs.For") }}
      </span>
      <span class="demo__inline demo__color--gradient">
        {{ $t("Subs.PTM") }}
      </span>
    </div>
    <a-row class="demo__margin-top--15 demo__margin-top-mobile--0">
      <a-col
        :xl="8"
        :lg="12"
        :md="12"
        :sm="24"
        :xs="24"
        v-for="(plan, index) in computedPlans"
        :key="plan.id"
      >
        <a-spin :spinning="plan.id === loading">
          <VerticalObjectBlock
            class="demo__text-center demo__margin-mobile-0 demo__margin-top-mobile--20"
            :object="plan"
            :no-image="true"
            :is-slot="true"
            :height="isMobile ? 'auto' : height"
            :demo="!plan.id"
            :padding="isMobile ? 5 : 4"
            margin-type="base"
            bg="white"
            color="black"
            :border="
              plan?.isActiveForUser && plan.id !== 1
                ? 'gradient'
                : !userIsBaseSub && !userIsCorpSub && index === 1
                ? 'gradient'
                : 'bgDescription'
            "
            :desc="false"
          >
            <div
              v-if="plan.id"
              class="demo__flex demo__flex-column demo__height-full"
            >
              <div
                class="demo__font--20 demo__weight--600 demo__font-mobile--16 demo__color--black"
              >
                {{ plan.name }}
              </div>
              <div
                class="demo__margin-top--30 demo__color--black demo__margin-top-mobile--16"
              >
                <span
                  class="demo__font--24 demo__font-mobile--18 demo__weight--600 demo__margin-right--5"
                >
                  {{ plan.cost }}
                </span>
                <span
                  v-if="plan.oldCost"
                  style="text-decoration: line-through"
                  class="demo__font--20 demo__color--textPrimaryGray"
                >
                  {{ plan.oldCost }}
                </span>
                <span
                  v-if="plan.costDescription"
                  class="demo__font--14 demo__weight--400"
                >
                  / {{ plan.costDescription }}
                </span>
              </div>
              <div>
                <div
                  v-for="feature in plan.features"
                  :key="feature.id"
                  class="demo__flex demo__flex-top demo__text-left demo__margin-top--16"
                >
                  <i
                    class="fa-solid fa-check demo__color--brandPrimary demo__font--16 demo__margin-right--8"
                  ></i>
                  <span class="demo__font--16 demo__weight--400">
                    {{ feature.name }}
                  </span>
                </div>
              </div>
              <div class="demo__flex-bottom" v-if="plan.button">
                <a-button
                  class="demo__button demo__button--full demo__margin-top-mobile--24"
                  @click="() => onClick(plan)"
                  :disabled="plan.button.disabled"
                  v-bind:class="{
                    ['demo__button--' + (plan.button.type || 'gradient')]: true,
                    [plan.button.class]: plan.button.class,
                  }"
                >
                  <span
                    v-if="
                      plan.button.active && !isModal && user?.plan?.auto_renew
                    "
                  >
                    {{ $t("Subs.yourSub") }}
                  </span>
                  <span v-else>
                    {{ plan.button.text }}
                  </span>
                </a-button>
              </div>
            </div>
          </VerticalObjectBlock>
        </a-spin>
      </a-col>
    </a-row>
    <a-row v-if="extInfo" type="flex" justify="space-around" align="middle">
      <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
        <div
          class="demo__flex demo__flex-between demo__flex-column-mobile demo__text-left-mobile"
          v-bind:class="{
            'demo__flex-middle': !isMobile,
            'demo__BubbleBlock--col': !isMobile,
          }"
        >
          <div
            class="demo__margin-top-mobile--10 demo__width-full demo__relative"
          >
            <a-input
              class="demo__input demo__radius--4"
              :placeholder="$t('Subs.EnterPromo')"
              v-model="promo"
              @blur="checkPromo"
              @change="
                () => {
                  this.promoError = undefined;
                }
              "
            >
              <i
                slot="suffix"
                class="fa-regular fa-paper-plane-top demo__margin-right--12"
                @click="checkPromo"
              ></i>
            </a-input>

            <p
              v-if="promoError"
              class="this_promoError demo__color--brandPrimary demo__margin-bottom--0"
            >
              {{ promoError }}
            </p>
          </div>
        </div>
      </a-col>
      <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
        <div
          class="demo__font--16 demo__weight--500 demo__underline demo__pointer demo__margin-top-mobile--10 demo__BubbleBlock--col demo__text-center demo__text-left-mobile demo__color--black"
          @click="goToPlansPage()"
        >
          {{ $t("Subs.PlansDesc") }}
        </div>
      </a-col>
      <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
        <div
          class="demo__font--16 demo__weight--500 demo__underline demo__pointer demo__margin-top-mobile--10 demo__BubbleBlock--col demo__text-right demo__text-left-mobile demo__color--black"
        >
          <a
            :href="userLinks.userAgreement"
            target="_blank"
            class="demo__color--black"
            >{{ $t("Subs.Offer") }}
          </a>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import VerticalObjectBlock from "Components/VerticalObjectBlock";

export default {
  props: {
    isModal: {
      type: Boolean,
      required: false,
      default: true,
    },
    height: {
      type: Number,
      required: false,
      default: 538,
    },
    extInfo: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    VerticalObjectBlock,
  },
  data() {
    return {
      promo: undefined,
      loading: false,
      promoLoading: false,
      promoError: undefined,
      corpRequested: false,
      apiCosts: [],
    };
  },
  computed: {
    ...mapGetters([
      "api",
      "user",
      "subsPlans",
      "userIsBaseSub",
      "isMobile",
      "userLinks",
      "userIsCorpSub",
    ]),
    computedPlans() {
      // Если промокод пуст или нет данных о скидках
      if (!this.promo || !this.apiCosts || this.apiCosts.length === 0) {
        return this.subsPlans;
      }

      return this.subsPlans.map((plan) => {
        const planDiscount = this.apiCosts.find((item) => item.id === plan.id);

        if (!planDiscount || !planDiscount.costs?.length) return plan;

        const costData = planDiscount.costs[0];
        return {
          ...plan,
          cost: `${this.formatPrice(costData.discount)} ${
            costData.currency.symbol
          }`,
          oldCost: `${this.formatPrice(costData.price)} ${
            costData.currency.symbol
          }`,
        };
      });
    },
  },
  watch: {
    corpRequested() {
      window?.localStorage.setItem("corpRequested", true);
    },
  },
  beforeDestroy() {
    this.$root.$off("changeSubLoading", this.changeSubLoading);
  },
  created() {
    this.$accessModule("subs", this);
    this.$root.$on("changeSubLoading", this.changeSubLoading);
  },
  methods: {
    changeSubLoading(loading) {
      this.loading = loading;
    },
    async goToPlansPage() {
      await this.$store.dispatch("updateSubsModalStatus", false);
      this.$router.push("/subscriptions");
    },
    formatPrice(priceStr) {
      if (!priceStr) return "";
      const num = parseFloat(priceStr);
      if (isNaN(num)) return priceStr;
      return num.toFixed(2).replace(/\.00$/, "");
    },
    async checkPromo() {
      // Сбрасываем цены при пустом промокоде
      if (!this.promo) {
        this.apiCosts = [];
        return;
      }

      this.promoLoading = true;
      this.apiCosts = []; // Сбрасываем перед новым запросом

      try {
        const res = await this.api.checkPromoCode({
          data: { promo_code: this.promo },
        });
        this.apiCosts = res.data;
        if (res.data.length === 0) {
          this.promoError = this.$t("Subs.promoNotActive");
        }
      } catch (error) {
        this.$debug("Ошибка проверки промокода", "error", error);
        this.apiCosts = []; // Сбрасываем при ошибке
        this.promoError = this.$t("Subs.promoNotFound");
      } finally {
        this.promoLoading = false;
      }
    },

    onClick(plan) {
      if (!plan.button.action) {
        return;
      }

      if (plan.button.active && !this.isModal) {
        return;
      }

      if (plan.button.action === "subscribe") {
        this.$root.subscribe(plan, this.promo);
      } else {
        this.$root[plan.button.action](plan);
      }
    },
  },
};
</script>
